import { render, staticRenderFns } from "./QuestionFourth.vue?vue&type=template&id=3e37d50c"
import script from "./QuestionFourth.vue?vue&type=script&lang=js"
export * from "./QuestionFourth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports